<template>
  <LoadingItem v-if="loading" />
  <div class="race-history-wrap">
    <div class="search-box">
      <div>
        <select v-model="searchQuery.searchType">
          <option value="name">이름</option>
          <option value="username">아이디</option>
        </select>
        <input
          style="width: 80px"
          v-model="searchQuery.searchText"
          @keypress.enter="getList(1)"
        />
        날짜
        <DatePic
          v-model:value="searchQuery.from"
          format="YYYY-MM-DD"
          value-type="format"
        />
        <span style="margin: 0 3px">~</span>
        <DatePic
          v-model:value="searchQuery.to"
          format="YYYY-MM-DD"
          value-type="format"
          style="margin-right: 5px"
        />
        <input type="button" value="기간검색" @click="getList(1)" />

        <input
          type="button"
          :value="$moment(date).subtract(1, 'days').format('YYYY-MM-DD')"
          @click="searchDate($event.target.value)"
          style="margin-left: 20px"
        />
        <span style="margin: 0 3px">{{ date }}</span>
        <input
          type="button"
          :value="$moment(date).add(1, 'days').format('YYYY-MM-DD')"
          @click="searchDate($event.target.value)"
        />
      </div>
    </div>
    <table class="bet-history-tb">
      <tr>
        <th>아이디</th>
        <th>이름</th>
        <th>경주지역</th>
        <th>경주</th>
        <th>승식</th>
        <th>1착</th>
        <th>2착</th>
        <th>3착</th>
        <th>머니형태</th>
        <th>배팅금액</th>
        <th>지급서비스머니</th>
        <th>당첨금액</th>
        <th>상태</th>
        <th>배팅일시</th>
      </tr>
      <tr v-for="item in list">
        <td>{{ item.user.username }}</td>
        <td>{{ item.user.name }}</td>
        <td>{{ item.location }}</td>
        <td>{{ item.round }}R</td>
        <td>{{ item.bet_type }}</td>
        <td>{{ item.first_player }}</td>
        <td>{{ item.second_player }}</td>
        <td>{{ item.third_player }}</td>
        <td>{{ item.money_type }}</td>
        <td>{{ $addCommas(item.bet_amount) }}</td>
        <td>{{ $addCommas(item.service_amount) }}</td>
        <td>
          <span v-if="item.win_amount > 0">{{
            $addCommas(item.win_amount)
          }}</span>
        </td>
        <td>
          <span v-if="item.status === 0">대기</span>
          <span v-if="item.status === 1">적중</span>
          <span v-if="item.status === 2">미적중</span>
          <span v-if="item.status === 3" style="color: #d941c5">유저환불</span>
          <span v-if="item.status === 4" style="color: blue">관리자환불</span>
          <span v-if="item.status === 5">취소</span>
        </td>
        <td>{{ item.created_at }}</td>
      </tr>
      <tr v-if="list.length > 0">
        <td colspan="8"></td>
        <td>합계</td>
        <td>{{ $addCommas(totalBetAmount) }}</td>
        <td>
          {{ totalServiceAmount != 0 ? $addCommas(totalServiceAmount) : "" }}
        </td>
        <td>{{ totalWinAmount != 0 ? $addCommas(totalWinAmount) : "" }}</td>
        <td colspan="2"></td>
      </tr>
    </table>
    <div class="pagination">
      <v-pagination
        v-model="searchQuery.page"
        :pages="totalPage"
        :range-size="1"
        active-color="#DCEDFF"
        @update:modelValue="getList()"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      searchQuery: {
        page: 1,
        size: 50,
        from: this.$moment().format("YYYY-MM-DD"),
        to: this.$moment().format("YYYY-MM-DD"),
        searchType: "name",
        searchText: "",
      },
      date: this.$moment().format("YYYY-MM-DD"),
      list: [],
      totalPage: 0,
      totalBetAmount: 0,
      totalServiceAmount: 0,
      totalWinAmount: 0,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList(page) {
      this.loading = true;

      if (page) {
        this.searchQuery.page = page;
      }

      this.date = this.searchQuery.from;

      this.$axios
        .get(`/race/history?${this.$qs.stringify(this.searchQuery)}`)
        .then((res) => {
          this.totalBetAmount = 0;
          this.totalServiceAmount = 0;
          this.totalWinAmount = 0;

          this.list = res.data.data;
          this.totalPage = res.data.totalPage;

          this.list.forEach((x) => {
            if (x.status === 0 || x.status === 1 || x.status === 2) {
              this.totalBetAmount += x.bet_amount;
              this.totalServiceAmount += x.service_amount;
              this.totalWinAmount += x.win_amount;
            }
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //날짜검색
    searchDate(e) {
      this.searchQuery.from = e;
      this.searchQuery.to = e;
      this.date = e;

      this.getList(1);
    },
  },
};
</script>
